var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountStatement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29 29a2 2 0 01-2 2H5a2 2 0 01-2-2V3a2 2 0 012-2h14.172a2 2 0 011.413.585l7.83 7.83A2 2 0 0129 10.828V29z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29 11h-8a2 2 0 01-2-2V1M7.523 12.459A2.961 2.961 0 0010 13.625c1.519 0 2.75-.924 2.75-2.062 0-1.139-1.23-2.063-2.75-2.063s-2.75-.924-2.75-2.064c0-1.14 1.231-2.062 2.75-2.062a2.961 2.961 0 012.477 1.166M10 13.625V15m0-11v1.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 19.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-7z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 23h18m-12-4v8m6-8v8"
  })));
}
export default SvgAccountStatement;